function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SideBySideTextAndAsset from "segments/desktop/core-components/side-by-side-text-and-asset/side-by-side-text-and-asset";
import { SPACE_BLUE_COLOR_NAME } from "styles/color-consts";
import AssetComponent from "components/core/asset/asset-component";
import SignupButton from "segments/desktop/core-components/button/signup-button/signup-button";
import TypedComponent from "segments/desktop/core-components/typed-component/typed-component";
import PictureComponent from "components/core/picture/picture-component";
import { SM } from "constants/sizes";
import VisibilitySensor from "react-visibility-sensor";
import { useState } from "react";
import ParallaxGalaxy from "../parallax-galaxy";
import { StyledScrollParallaxHomepageFirstFoldMobileComponent } from "./scroll-parallax-homepage-first-fold-mobile-component.scss";
import { getTypings, PERSONS_IMAGES } from "../config";
const ScrollParallaxHomepageFirstFoldMobileComponent = (props)=>{
    const VISIBILITY_SENSOR_OFFSET = 0;
    const [shouldRerenderWhenVisible, setShouldRerenderWhenVisible] = useState(false);
    const { paragraphs, topAsset, bottomAsset, translate } = props;
    const mobileParagraphs = paragraphs.map((paragraph)=>({
            paragraph: {
                title: paragraph.title,
                titleSize: SM,
                body: paragraph.description,
                topic: ""
            }
        }));
    const topAssetComponent = ()=>{
        return /*#__PURE__*/ _jsxs("div", {
            className: "top-asset-wrapper",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "parallax-galaxy-wrapper",
                    children: /*#__PURE__*/ _jsx(ParallaxGalaxy, {})
                }),
                /*#__PURE__*/ _jsx(AssetComponent, {
                    image: topAsset,
                    useWindowMask: true
                })
            ]
        });
    };
    const middleAssetComponent = ()=>{
        const getComponentProps = (index)=>{
            const delays = [
                250,
                3000,
                5500
            ];
            return {
                typedProps: {
                    strings: [
                        `${getTypings(translate)[index]}`
                    ],
                    startDelay: delays[index]
                }
            };
        };
        const onVisibilityChange = (isVisible)=>{
            if (!shouldRerenderWhenVisible && isVisible) {
                setShouldRerenderWhenVisible(true);
            }
        };
        return /*#__PURE__*/ _jsx(VisibilitySensor, {
            offset: {
                bottom: VISIBILITY_SENSOR_OFFSET,
                top: VISIBILITY_SENSOR_OFFSET
            },
            partialVisibility: true,
            active: true,
            scrollCheck: true,
            onChange: onVisibilityChange,
            children: /*#__PURE__*/ _jsx("div", {
                className: "middle-asset-wrapper",
                children: PERSONS_IMAGES.map((value, index)=>/*#__PURE__*/ _jsxs("div", {
                        className: "typing-wrapper",
                        children: [
                            /*#__PURE__*/ _jsx(PictureComponent, _object_spread({}, PERSONS_IMAGES[index].image)),
                            shouldRerenderWhenVisible && /*#__PURE__*/ _jsx(TypedComponent, _object_spread({}, getComponentProps(index)))
                        ]
                    }, index))
            })
        });
    };
    const bottomAssetComponent = ()=>{
        return /*#__PURE__*/ _jsx("div", {
            className: "bottom-asset-wrapper",
            children: /*#__PURE__*/ _jsx(AssetComponent, {
                video: bottomAsset,
                useWindowMask: true
            })
        });
    };
    return /*#__PURE__*/ _jsxs(StyledScrollParallaxHomepageFirstFoldMobileComponent, {
        className: "scroll-parallax-homepage-first-fold-mobile-component",
        children: [
            /*#__PURE__*/ _jsx(SideBySideTextAndAsset, {
                background: {
                    color: SPACE_BLUE_COLOR_NAME,
                    width: "100%"
                },
                fullParagraph: mobileParagraphs[0].paragraph,
                replaceAssetComponent: topAssetComponent,
                contentClassName: "top-paragraph-and-asset"
            }),
            /*#__PURE__*/ _jsx(SideBySideTextAndAsset, {
                background: {
                    color: SPACE_BLUE_COLOR_NAME,
                    width: "100%"
                },
                fullParagraph: mobileParagraphs[1].paragraph,
                replaceAssetComponent: middleAssetComponent,
                contentClassName: "middle-paragraph-and-asset"
            }),
            /*#__PURE__*/ _jsx(SideBySideTextAndAsset, {
                background: {
                    color: SPACE_BLUE_COLOR_NAME,
                    width: "100%"
                },
                fullParagraph: mobileParagraphs[2].paragraph,
                replaceAssetComponent: bottomAssetComponent,
                contentClassName: "bottom-paragraph-and-asset"
            })
        ]
    });
};
export default ScrollParallaxHomepageFirstFoldMobileComponent;
